/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/borderlesscreatures/"

const borderlessCreatures: CommunityData = {
  code: "borderlesscreatures",
  inviteCode: "borderlesscreatures",
  name: "Borderless Creatures",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/bcr-030`,
  waitlist: true,
  socials: {},
  styles: {
    global: {
      counterColor: "#e890f4",
      werzLogoColor: "#e890f4",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[196px] h-[50px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[196px] h-[50px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#171c39",
      // Navbar filled (vrau-style: same fill as page bg), minimal styles (no gap/padding), #94abf9 right divider
      asideBg: "#94abf9",
      asideStyles: "!p-0 !gap-0 border-r border-[#94abf9]",
      contentBg: "#171c39",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      mainFont: "font-['CooperHewittBook']",
      primaryButton:
        "bg-[#e890f4] border-2 border-[#e890f4] rounded-[8px] px-[18px] py-[18px] !text-[#171c39] font-['CooperHewittHeavy'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#94abf9",
      sideBarSeparator: "!border-r-[1px] border-[#94abf9]",
      separator: "border-[#94abf9]",
      // #94abf9 foreground on filled navy navbar, centered, upper, CooperHewittSemibold 16, columnGap 10
      // (vrau-style: items inherit aside bg — no explicit pill bg; opacity affordance for selected)
      item: "font-['CooperHewittSemibold'] text-[16px] text-[#171c39] uppercase text-center leading-[100%] gap-x-[10px] !pl-0 !py-3 text-opacity-50",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      // CUSTOM OVERRIDE — container copied from reference (bg + pb)
      container: "!bg-[#171c39] !pb-8",
      // TITLES — accent pink, CooperHewittHeavy 28, upper
      titles:
        "text-[#e890f4] font-['CooperHewittHeavy'] text-[28px] uppercase text-left leading-[120%]",
      // EMPTY OR LOADING — accent pink, CooperHewittBook 15
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#e890f4] font-['CooperHewittBook'] text-[15px] text-left leading-[120%]",
      announcementsV2: {
        // CUSTOM OVERRIDE — sectionContainer + scrollMenu copied from reference
        sectionContainer:
          "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-solid border-[#94abf9]",
        sectionTitle:
          "text-[#e890f4] font-['CooperHewittHeavy'] text-[28px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          // CUSTOM OVERRIDE — overflow hidden; item bg #171c39 (item border skipped per web post-adjust doc)
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#171c39]",
          // vrau spacing — square aspect media, no rounding
          mediaContainer: "w-full sm:w-[256px] relative overflow-hidden",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          // vrau spacing — vertical padding only
          content: "flex flex-col py-4 bg-[#171c39]",
          title:
            "text-[#e890f4] font-['CooperHewittHeavy'] text-[16px] uppercase text-left leading-[120%]",
          subtitle:
            "text-[#e890f4] font-['CooperHewittBook'] text-[13px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        // CUSTOM OVERRIDE — sectionContainer + scrollMenu copied from reference
        sectionContainer:
          "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-solid border-[#94abf9]",
        sectionTitle:
          "text-[#e890f4] font-['CooperHewittHeavy'] text-[28px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          // CUSTOM OVERRIDE — overflow hidden; item bg #171c39 (item border skipped per web post-adjust doc)
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#171c39]",
          // vrau spacing — fixed desktop width, video aspect drives height (no fixed height)
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          // vrau spacing — full-width media on mobile (px-0 py-4), aligned with image top on desktop
          content: "flex flex-col px-0 sm:px-4 py-4 sm:!py-0 bg-[#171c39]",
          // title — accent pink, CooperHewittHeavy 16, upper
          title:
            "text-[#e890f4] font-['CooperHewittHeavy'] text-[16px] uppercase text-left leading-[120%]",
          subtitle:
            "text-[#e890f4] font-['CooperHewittBook'] text-[13px] text-left leading-[120%] mt-2",
          // location — accent pink, CooperHewittBook 13
          location:
            "text-[#e890f4] font-['CooperHewittBook'] text-[13px] text-left leading-[120%] mt-1",
          // date — accent pink, CooperHewittBook 13
          date: "text-[#e890f4] font-['CooperHewittBook'] text-[13px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        // title — accent pink, CooperHewittHeavy 24, upper
        title:
          "text-[#e890f4] font-['CooperHewittHeavy'] text-[24px] uppercase text-left leading-[120%]",
        // text — light blue, CooperHewittBook 17
        text: "text-[#94abf9] font-['CooperHewittBook'] text-[17px] text-left leading-[120%]",
        // customShopImageStyle — shop images have no border on web (post-adjust doc)
        customShopImageStyle: "",
        sectionTitle:
          "text-[#e890f4] font-['CooperHewittHeavy'] text-[28px] uppercase text-left leading-[120%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      // CONTAINER — bg #171c39, paddingBottom 32
      container: "flex flex-col !bg-[#171c39] !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-solid border-[#94abf9]",
        // CUSTOM OVERRIDE — fixed media size; no border on web (post-adjust doc); no rounding
        media: "sm:!w-[320px] !w-full sm:!h-[180px] !h-[180px] object-cover sm:mb-4",
        // title — accent pink, CooperHewittHeavy 28, upper
        title:
          "text-[#e890f4] font-['CooperHewittHeavy'] text-[28px] uppercase text-left leading-[120%]",
        // subtitle — accent pink, CooperHewittBook 15
        subtitle:
          "text-[#e890f4] font-['CooperHewittBook'] text-[15px] text-left leading-[120%] mb-4 mt-2",
        // button — bg #e890f4, border 2 #e890f4, radius 8, px/py 18, rowGap 6; text #171c39 CooperHewittHeavy 16
        button:
          "bg-[#e890f4] border-2 border-[#e890f4] rounded-[8px] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 gap-y-[6px] text-[#171c39] font-['CooperHewittHeavy'] !text-[16px] text-left leading-[100%]",
        // questions — 15, left, 120%
        questions: "text-[15px] text-left leading-[120%] text-[#e890f4]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-solid border-[#94abf9]",
        // header — accent pink, CooperHewittHeavy 24, upper
        header:
          "text-[#e890f4] font-['CooperHewittHeavy'] text-[24px] uppercase text-left leading-[120%]",
        // text — light blue, CooperHewittBook 15
        text: "text-[#94abf9] font-['CooperHewittBook'] text-[15px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-solid border-[#94abf9]",
        // header — accent pink, CooperHewittHeavy 24, upper
        header:
          "text-[#e890f4] font-['CooperHewittHeavy'] text-[24px] uppercase text-left leading-[120%]",
        // text — light blue, CooperHewittBook 15
        text: "text-[#94abf9] font-['CooperHewittBook'] text-[15px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        // CUSTOM OVERRIDE — map overflow-hidden, rowGap 10
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#e890f4",
        mapStrokeColor: "#e890f400",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#e890f4] font-['CooperHewittHeavy'] text-[24px] uppercase text-left leading-[120%]",
        text: "text-[#94abf9] font-['CooperHewittBook'] text-[15px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#e890f4] font-['CooperHewittHeavy'] text-[24px] uppercase text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4",
        // OUTER CONTAINER — bg #171c39, paddingBottom 32 (border handled by parent container)
        outerContainer: "flex flex-col !bg-[#171c39] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        ticket: {
          // vrau spacing — vertical padding only; border-b separates tickets (no horizontal padding, no margin)
          container:
            "flex flex-row justify-between leading-auto !bg-[#171c39] border-b border-[#94abf9] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          // name — accent pink, CooperHewittHeavy 16, upper
          name: "text-[#e890f4] font-['CooperHewittHeavy'] text-[16px] uppercase text-left leading-[120%] mb-1",
          // description — accent pink, CooperHewittBook 15
          description:
            "text-[#e890f4] font-['CooperHewittBook'] text-[15px] text-left leading-[120%] mb-1 flex flex-row",
          // price — accent pink, CooperHewittHeavy 16, upper
          price:
            "text-[#e890f4] font-['CooperHewittHeavy'] text-[16px] uppercase text-left leading-[120%]",
          // quantity — accent pink, CooperHewittHeavy 14
          quantity:
            "text-[#e890f4] font-['CooperHewittHeavy'] text-[14px] text-left leading-[100%]",
          // status — accent pink, CooperHewittHeavy 16, upper
          status:
            "text-[#e890f4] font-['CooperHewittHeavy'] text-[16px] uppercase text-left leading-[120%]",
          // counterContainer — bg #171c39, border 2 #94abf9, radius 8, px/py 16, columnGap 16
          counterContainer:
            "bg-[#171c39] border-2 border-[#94abf9] rounded-[8px] px-[16px] py-[16px] gap-x-[16px] !w-fit !h-10",
          // buyButton — bg #171c39, border 2 #94abf9, radius 8, px/py 16; text #e890f4 CooperHewittHeavy 14
          button:
            "bg-[#171c39] border-2 border-[#94abf9] rounded-[8px] px-[16px] py-[16px] text-[#e890f4] font-['CooperHewittHeavy'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#e890f4",
        },
      },
    },
    // Derived from web styles per .agents/skills/onboard-community/references/wm.md#coming-soon-page (dark navy theme)
    comingSoon: {
      bgColor: "#171c39", // global.contentBg
      hero: {
        desktop: `${S3_PREFIX}web-background-non-member.mp4?type=video`, // invite landing bg media (nonMemberBg)
        mobile: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
        style: "bg-[#0f1226]", // darker fallback for dark theme
      },
      logo: {
        // CUSTOM — use alternative logo on coming soon
        desktop: `${S3_PREFIX}mobile-landing-logo.png`,
        mobile: `${S3_PREFIX}mobile-landing-logo.png`,
        style: "w-[140px] h-[36px] sm:w-[196px] sm:h-[50px]", // desktop from web logo dims, mobile scaled
      },
      werzLogoColor: "#FFFFFF", // manual — white on dark bg
      title: "font-['CooperHewittHeavy'] text-[28px] leading-[120%] text-[#e890f4] uppercase", // communityLanding.titles
      text: "font-['CooperHewittBook'] text-[17px] leading-[120%] text-[#94abf9]", // communityLanding.shop.text
      button:
        "font-['CooperHewittHeavy'] text-[16px] leading-[100%] p-4 bg-[#e890f4] border-2 border-[#e890f4] rounded-[8px] text-[#171c39] cursor-pointer w-fit", // global.primaryButton
      input: {
        base: "font-['CooperHewittBook'] text-[15px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#0f1226] text-[#ffffff]",
        border: "#94abf9",
        borderFocus: "#e890f4",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['CooperHewittBook'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['CooperHewittBook'] text-[14px] leading-[120%] text-[#94abf9]", // date text tone
      skipButton:
        "font-['CooperHewittBook'] text-[14px] leading-[120%] text-[#94abf9] cursor-pointer",
      modal: {
        container: "bg-[#1f254a] px-[40px] py-[48px]", // variant of bgColor
        title:
          "font-['CooperHewittHeavy'] text-[24px] leading-[120%] text-[#e890f4] text-center uppercase",
        text: "font-['CooperHewittBook'] text-[14px] leading-[120%] text-[#94abf9] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#ffffff] bg-[#0f1226] font-['CooperHewittBook'] text-[16px] leading-[120%] text-center",
        otpBorder: "#94abf9",
        otpBorderFocus: "#e890f4",
      },
    },
    // Derived from WM atoms per .agents/skills/onboard-community/references/wm.md#links-page (radioradio layout shapes)
    linktree: {
      bgDesktop: `${S3_PREFIX}web-background-non-member.mp4?type=video`, // wmInviteDesktopBg (nonMemberBg)
      bgMobile: `${S3_PREFIX}web-background-non-member.mp4?type=video`, // wmInviteMobileBg (nonMemberBg)
      bgColor: "#171c39",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative bg-[#171c39] p-[64px]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] border-[#94abf9]",
        name: "text-[28px] mt-2 text-[#e890f4] font-['CooperHewittHeavy'] leading-[120%] uppercase", // mmNewsDetailTitle
        location: "text-[14px] text-[#94abf9] font-['CooperHewittBook'] mb-2", // mmNewsItemTitle tone
        description:
          "text-[17px] leading-[120%] text-[#94abf9] text-center mb-4 font-['CooperHewittBook']", // wmBodyText
        socialMediaIconColor: "#e890f4",
        button:
          "flex justify-center items-center bg-[#171c39] border-2 border-[#94abf9] rounded-[8px] px-[24px] py-[12px] text-[#e890f4] font-['CooperHewittHeavy'] text-[12px] leading-[100%] cursor-pointer", // wmTicketButton
      },
      upcomingEvents: {
        header:
          "text-[20px] mb-[10px] text-center text-[#e890f4] font-['CooperHewittHeavy'] leading-[120%] uppercase", // wmLandingTitle color
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        loadingState:
          "mb-[32px] bg-[#171c39] font-['CooperHewittBook'] text-[#94abf9] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#94abf9] rounded-[8px]",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] rounded-[8px] bg-[#171c39] flex flex-col justify-center items-center border border-[#94abf9] p-[34px] mb-[32px]",
          title: "text-[#e890f4] text-[14px] mb-1 font-['CooperHewittHeavy'] uppercase",
          text: "text-[14px] text-[#94abf9] font-['CooperHewittBook']",
          button:
            "flex justify-center items-center mt-4 bg-[#171c39] text-[#e890f4] text-[12px] px-[12px] py-[12px] border-2 border-[#94abf9] rounded-[8px] font-['CooperHewittHeavy'] cursor-pointer",
        },
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] bg-[#171c39] w-[95vw] rounded-[8px] flex justify-between border border-[#94abf9]",
          duration: "text-[12px] text-[#94abf9] font-['CooperHewittBook']",
          name: "text-[16px] leading-[120%] text-[#e890f4] one-line-truncate sm:w-[390px] w-[65vw] font-['CooperHewittHeavy']",
          plusIconColor: "#e890f4",
          media: "border border-[#94abf9] overflow-hidden rounded-[8px] m-2",
        },
        event: {
          container:
            "border border-[#94abf9] rounded-[8px] bg-[#171c39] overflow-hidden sm:w-[500px] w-[95vw]",
          name: "text-[20px] mb-1 text-[#e890f4] font-['CooperHewittHeavy'] one-line-truncate sm:w-[370px] w-[60vw] uppercase",
          startDate:
            "w-[64px] h-[64px] rounded-[6px] bg-[#e890f4] text-[#171c39] flex flex-col justify-center items-center gap-1 font-['CooperHewittHeavy']",
          duration: "text-[12px] text-[#94abf9] font-['CooperHewittBook']",
          location: "text-[12px] text-[#94abf9] font-['CooperHewittBook']",
          button:
            "flex justify-center items-center mt-3 bg-[#171c39] text-[#e890f4] text-[12px] px-[12px] py-[12px] border-2 border-[#94abf9] rounded-[8px] font-['CooperHewittHeavy'] cursor-pointer",
          product: {
            container: "h-[68px] border-t border-[#94abf9] px-4 py-3 flex justify-between",
            name: "text-[16px] text-[#e890f4] font-['CooperHewittHeavy'] one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#e890f4] text-[12px] font-['CooperHewittHeavy']",
            link: "text-[#94abf9] text-[12px] font-['CooperHewittBook']",
            status: "text-[#e890f4] text-[14px] font-['CooperHewittHeavy']",
            button:
              "flex justify-center items-center bg-[#171c39] text-[#e890f4] text-[12px] px-[12px] py-[8px] border-2 border-[#94abf9] rounded-[8px] font-['CooperHewittHeavy'] cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#94abf9] text-[16px] font-['CooperHewittBook'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        loadingState:
          "mb-[32px] bg-[#171c39] font-['CooperHewittBook'] text-[#94abf9] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#94abf9] rounded-[8px]",
        header:
          "text-[20px] mb-[10px] text-center text-[#e890f4] font-['CooperHewittHeavy'] leading-[120%] uppercase",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer bg-[#171c39] sm:w-[500px] w-[95vw] rounded-[8px] flex justify-between border border-[#94abf9]",
          name: "text-[16px] leading-[120%] text-[#e890f4] one-line-truncate sm:w-[390px] w-[65vw] font-['CooperHewittHeavy']",
          triangleIconColor: "#e890f4",
          created: "text-[#94abf9] text-[12px] font-['CooperHewittBook']",
          media: "border border-[#94abf9] overflow-hidden rounded-[8px] m-2",
        },
        seeAllNews:
          "text-[#94abf9] text-[16px] font-['CooperHewittBook'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      radioTracks: {
        header:
          "text-[20px] mb-[10px] text-center text-[#e890f4] font-['CooperHewittHeavy'] leading-[120%] uppercase",
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[32px] bg-[#171c39] font-['CooperHewittBook'] text-[#94abf9] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#94abf9] rounded-[8px]",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer bg-[#171c39] sm:w-[500px] w-[95vw] rounded-[8px] flex justify-between border border-[#94abf9]",
          title:
            "text-[16px] leading-[120%] text-[#e890f4] one-line-truncate sm:w-[390px] w-[65vw] font-['CooperHewittHeavy']",
          duration: "text-[#94abf9] text-[12px] font-['CooperHewittBook']",
          liveType: "text-[#94abf9] text-[12px] font-['CooperHewittBook']",
          liveTypeCircle: "#e890f4",
          playIconColor: "#171c39",
          playIconBackgroundColor: "#e890f4",
          playIconBorderColor: "#e890f4",
          start: "text-[#94abf9] text-[12px] font-['CooperHewittBook']",
          coverUrl: "border border-[#94abf9] overflow-hidden rounded-[8px] m-2",
        },
        seeAllTracks:
          "text-[#94abf9] text-[16px] font-['CooperHewittBook'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] bg-[#171c39] font-['CooperHewittBook'] text-[#94abf9] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#94abf9] rounded-[8px]",
        header:
          "text-[20px] mb-[10px] text-center text-[#e890f4] font-['CooperHewittHeavy'] leading-[120%] uppercase",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] bg-[#171c39] w-[95vw] rounded-[8px] flex justify-between border border-[#94abf9]",
          name: "text-[15px] text-[#e890f4] font-['CooperHewittHeavy']",
          triangleIconColor: "#e890f4",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#94abf9] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#FFFFFF",
        text: "",
      },
    },
  },
}

export default borderlessCreatures
